module.exports = __webpack_public_path__ + "img/Elisa.e65c75ce.jpeg";